import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AboutIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AboutIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 20.9423C11.9062 20.9423 11.813 20.9165 11.731 20.8642C11.7012 20.8452 8.68653 18.9638 3.45459 18.6425C2.63916 18.5927 2 17.9043 2 17.0761V4.61079C2 4.17817 2.17432 3.77681 2.49121 3.48091C2.8081 3.18403 3.23877 3.0312 3.67432 3.0605C9.08741 3.42622 12.1421 5.34614 12.2695 5.42769C12.4131 5.51949 12.5 5.67818 12.5 5.84859V20.4428C12.5 20.6255 12.4004 20.7929 12.2402 20.8808C12.1655 20.9218 12.0825 20.9423 12 20.9423ZM3.56592 4.05708C3.41944 4.05708 3.28174 4.11079 3.17432 4.21138C3.06202 4.31636 3 4.45796 3 4.61079V17.0761C3 17.3769 3.22656 17.6269 3.51611 17.6445C7.51367 17.8901 10.2495 18.9868 11.5 19.602V6.13716C10.7109 5.70454 7.93164 4.35054 3.60693 4.05855C3.59326 4.05757 3.5796 4.05708 3.56592 4.05708Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 20.9423C11.9175 20.9423 11.8345 20.9218 11.7598 20.8808C11.5996 20.7929 11.5 20.6255 11.5 20.4428V5.84859C11.5 5.67818 11.5869 5.51949 11.7305 5.4272C11.8579 5.34615 14.9136 3.42671 20.3262 3.0605C20.7544 3.02974 21.1909 3.18404 21.5088 3.48042C21.8257 3.77681 22 4.17817 22 4.61079V17.0761C22 17.9042 21.3608 18.5927 20.5454 18.6425C15.3135 18.9638 12.2988 20.8452 12.269 20.8642C12.187 20.9165 12.0938 20.9423 12 20.9423ZM12.5 6.13716V19.602C13.7505 18.9868 16.4863 17.8901 20.4839 17.6445C20.7734 17.6269 21 17.3769 21 17.0761V4.61079C21 4.45796 20.938 4.31587 20.8257 4.21089C20.7085 4.10151 20.5537 4.04683 20.3935 4.05855C16.0688 4.35054 13.2891 5.70455 12.5 6.13716Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AboutIcon;
